<script lang="ts">
  import { UIEventSource } from "../../../Logic/UIEventSource"
  import tag2link from "tag2link/index.json"

  export let tags: UIEventSource<Record<string, any>>
  export let key: string

  const tag2linkData = tag2link as Tag2LinkElement[]

  interface Tag2LinkElement {
    /**
     * OSM tag key
     */
    key: string

    /**
     * URL template or formatter URL: replace `$1` with the tag value
     */
    url: string

    /**
     * Source of this formatter URL
     */
    source?: string

    /**
     * Rank or relative importance of this formatter URL.
     */
    rank?: "preferred" | "normal" | "deprecated"
  }

  const url = tag2linkData.find((item) => item.key === `Key:${key}`)?.url

  let values: string[] =
    typeof $tags[key] === "string" ? $tags[key].split(";").map((v: string) => v.trim()) : []
</script>

{#if url && values.length > 0}
  {#each values as value, index}
    <span class="tag-link">
      {#if index > 0}; {/if}
      <a href={url.replace("$1", value)} target="_blank" rel="noopener noreferrer" class="tag-link">
        {value}
      </a>
    </span>
  {/each}
{:else}
  {$tags[key]}
{/if}
